<template>
  <component :is="way" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" />
</template>

<script>
import TabCompetencesDefault from "./TabCompetencesDefault"
import PROCESS_NAMES from "@/process/names";

const TabCompetencesJapan517 = () =>
  import(/* webpackChunkName: "tab-competences-japan" */ "@/process/japan-517/components/response/tabs/TabCompetences")

export default {
  name: "tab-competences",

  components: {
    TabCompetencesDefault,
    TabCompetencesJapan517
  },

  computed: {
    ...mapGetters('process', ['getProcessName']),

    way() {
      if (this.getProcessName === PROCESS_NAMES.JAPAN_517) {
        return `tab-competences-japan-517`;
      } else {
        return `tab-competences-default`;
      }
    }
  }
};
</script>
